import type { RouteRecordRaw } from 'vue-router'

import { routeFilesHome, routeFilesRoot } from './filesRoutes'

const routeFileSystemHome: RouteRecordRaw = {
  name: 'file-system',
  path: '',
  // TODO: handles url query here via redirect: (to: RouteLocation) => RouteLocationRaw function
  redirect: routeFilesHome,
}

const routeFileSystemRoot: RouteRecordRaw = {
  children: [routeFileSystemHome, routeFilesRoot],

  path: 'file-system',
}

export { routeFileSystemRoot }
